import * as Sentry from '@sentry/browser';
import { toaster } from '@/utils/toaster';

export function withNonCriticalErrorHandlingAsync(f) {
  return async (...args) => {
    try {
      await f(...args);
    } catch (e) {
      toaster.error('An unexpected error has occurred.');
      Sentry.captureException(e);
    }
  };
}
